import { copyDeep } from '@/shared'
import { IStateStoreAnnouncementAdvisor } from '@/modules/advisor/modules/announcement/shared/@types'
import { HttpStatusCode, TypeNotify } from '@/shared/enums'
import {
    customUrlImage,
    customUrlPdf,
    NotificationCustom,
    objectHasKey
} from '@/shared/function'
import { IPayloadSearchAnnounce } from '@/shared/@types'
import AnnounceAdvisorService from '@/modules/advisor/modules/announcement/services'
import router from '@/router'
import { RouterAdvisorUrl } from '@/modules/advisor/shared/enums'
import { IParamUpdateStatusAnnouncementById } from '@/modules/adminFQA/modules/announcement/shared/@types'

export const defaultStateAnnouncementAdvisor: IStateStoreAnnouncementAdvisor = {
    data: {}
}

const state = () => copyDeep(defaultStateAnnouncementAdvisor)

const getters = {
    getDataAnnouncementAdvisor(state: IStateStoreAnnouncementAdvisor) {
        return state.data
    }
}

const mutations = {
    setDataInquiryAnnouncement(
        state: IStateStoreAnnouncementAdvisor,
        payload: any
    ) {
        state.data = payload
    }
}

const actions = {
    async getDataAnnouncement(
        { commit }: any,
        payload: IPayloadSearchAnnounce
    ) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdvisorService.apiGetAnnounce(payload)
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataInquiryAnnouncement', data.data)
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async getDataDetailAnnouncement({ commit }: any, id: number) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdvisorService.apiGetAnnounceDetail(id)
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                if (data.data && objectHasKey(data.data, 'file_link')) {
                    data.data.file_link = customUrlPdf(data.data.file_link)
                }

                commit('setDataInquiryAnnouncement', data.data)
                return data.data
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
            router.push(RouterAdvisorUrl.announcement)
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async updateStatusAnnouncement({ commit, dispatch }: any) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceAdvisorService.apiUpdateStatusAnnounce()
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                return true
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async updateStatusAnnouncementById(
        { commit, dispatch }: any,
        payload: IParamUpdateStatusAnnouncementById
    ) {
        try {
            const res =
                await AnnounceAdvisorService.apiUpdateStatusAnnounceById(
                    payload
                )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                dispatch('signupAuth/countNotifyAdvisor', true, { root: true })
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (e) {}
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
